import styled, { css } from 'styled-components';


export const ItemsTransactionsReportTable = styled.div`
  display: grid;
  grid-template-columns: ${({ transaction }) =>
    transaction
      ? '0.8fr 1fr 1fr 0.6fr 1fr 1fr 0.6fr 1fr 1fr 1fr 1fr 0.7fr 50px'
      : '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1.2fr 70px'};
  grid-column-gap: 15px;
  justify-content: space-between;
  padding: 0 15px;
  border-bottom: ${({ heading, theme }) =>
    heading && `1px solid ${theme.colors.border.secondary}`};

  :nth-of-type(even) {
    background-color: ${({ heading }) => !heading && `#f8f9fc`};
  }
  & > :nth-child(n + 0) {
    justify-self: center;
  }
  & > :last-child {
    display: flex;
    justify-self: start;
    align-items: center;
  }
`;
